import ChartDoughnut from "./ChartDoughnut";
import React, {useEffect, useState} from "react";
import {RiAlignJustify} from "react-icons/ri";
import {getFetcherAnalysis} from "../../utils/fetcher_gameAnlysis";
import {GET_RECENTLY_RECORD_DATA_API} from "../../constants/api_constants";
import {ModalHandler} from "../Modal/Generic/ModalHandler";
import RecordDataTable from "./RecordDataTable";
import {getImage} from "../../constants/constants";
import neverLandUtils from "../../utils/NeverLandUtils";

const buttonData = [
  {name: "전체", value: 1},
  {name: "홈/원정", value: 2},
]

const RecentlyRecordeComponent = ({dataId, analysisType}) => {

  const chartDataList = [
    [{data: [0, 0, 0], backgroundColor: ["#e82049", "#f88f17", "#314bca"]},], // 홈팀 승무패
    [{data: [0, 0, 0], backgroundColor: ["#e82049", "#f88f17", "#314bca"]},], // 원정팀 승무패
  ];

  const [dataList, setDataList] = useState(chartDataList);
  const [showOptionButton, setShowOptionButton] = useState(false);
  const [optionButtonValue, setOptionButtonValue] = useState(buttonData[0].value);
  const [homeTeamName, setHomeTeamName] = useState(null);
  const [awayTeamName, setAwayTeamName] = useState(null);
  const [homeRecordData, setHomeRecordData] = useState([]);
  const [awayRecordData, setAwayRecordData] = useState([]);
  const [homeRecordStats, setHomeRecordStats] = useState({win: 0, draw: 0, lose: 0, count: 0});
  const [awayRecordStats, setAwayRecordStats] = useState({win: 0, draw: 0, lose: 0, count: 0});
  const [isLoading, setIsLoading] = useState(true);
  const [isNullData, setIsNullData] = useState(false);

  useEffect(() => {
    getRecentlyRecordeData();
  }, [optionButtonValue]);

  function __normalizeData(recordData, teamName) {
    let _recordData = JSON.parse(JSON.stringify(recordData));
    // 이미 teamName 데이터에 포함되어 있다면 그대로 반환
    for (let recordItem of _recordData) {
      if (recordItem.homeTeam === teamName || recordItem.awayTeam === teamName) {
        return _recordData;
      }
    }
    // 일치하지 않으면 카운트 가장 많은 팀이름으로 교체
    let jsonTeamCounts = {};
    let teamNames = [];

    for (let recordItem of _recordData) {
      if (!teamNames.includes(recordItem.homeTeam)) {
        teamNames.push(recordItem.homeTeam);
      }
      if (!teamNames.includes(recordItem.awayTeam)) {
        teamNames.push(recordItem.awayTeam);
      }

      // 홈 팀 빈도 증가
      jsonTeamCounts[recordItem.homeTeam] =
          (jsonTeamCounts[recordItem.homeTeam] || 0) + 1;
      // 어웨이 팀 빈도 증가
      jsonTeamCounts[recordItem.awayTeam] =
          (jsonTeamCounts[recordItem.awayTeam] || 0) + 1;
    }

    // 가장 빈도가 높은 팀 이름 찾기
    let currentTeamName = teamName;
    let currentTeamCount = 0;
    for (let _teamName of teamNames) {
      let tempCount = jsonTeamCounts[_teamName];
      if (tempCount > currentTeamCount) {
        currentTeamCount = tempCount;
        currentTeamName = _teamName;
      }
    }

    // 팀 이름을 teamName 으로 교체
    if (currentTeamCount > 0) {
      for (let recordItem of _recordData) {
        if (recordItem.homeTeam === currentTeamName) {
          recordItem.homeTeam = teamName;
        }
        if (recordItem.awayTeam === currentTeamName) {
          recordItem.awayTeam = teamName;
        }
      }
      // 대체 후 데이터
      return _recordData;
    }
    //변경 없이 반환
    return _recordData;
  }

  function setRecodeDataToGraph(graphData, recordData, teamName, dataIndex) {
    // 데이터에서 총 경기수 / 승 / 무 / 패 각각 카운트
    let _recordData = __normalizeData(recordData, teamName);

    let win = 0;
    let draw = 0;
    let lose = 0;
    let count = 0;

    for (let recordItem of _recordData) {
      if (recordItem.homeTeam === teamName || recordItem.awayTeam === teamName) {
        count++;
        if (recordItem.homeScore === recordItem.awayScore) {
          draw++;
        } else if (
            (recordItem.homeTeam === teamName && recordItem.homeScore > recordItem.awayScore) ||
            (recordItem.awayTeam === teamName && recordItem.awayScore > recordItem.homeScore)
        ) {
          win++;
        } else {
          lose++;
        }
      }
    }
    if (count > 0) {
      graphData[dataIndex][0].data[0] = Math.floor((win * 100) / count);
      graphData[dataIndex][0].data[1] = Math.floor((draw * 100) / count);
      graphData[dataIndex][0].data[2] = Math.floor((lose * 100) / count);
    } else {
      graphData[dataIndex][0].data = [0, 0, 0];
    }
    return {win, draw, lose, count};
  }

  const getRecentlyRecordeData = () => {
    // 최근 전적
    getFetcherAnalysis().get(GET_RECENTLY_RECORD_DATA_API + `?dataId=${dataId}&recordType=${optionButtonValue}&analysisType=${analysisType}`)
        .then(res => {
          const {responseIsSuccess, data, responseResultDescription} = res.data;
          if (responseIsSuccess) {
            if (data[0].homeRecordData.length === 0 && data[0].awayRecordData.length === 0) {
              setIsNullData(true);
              setIsLoading(false);
              return;
            }
            const _homeTableData = data[0]?.homeRecordData || [];
            const _awayTableData = data[0]?.awayRecordData || [];
            let _homeTeamName = data[0].homeTeamName;
            let _awayTeamName = data[0].awayTeamName;

            const normalizedHomeData = __normalizeData(_homeTableData, _homeTeamName);
            const normalizedAwayData = __normalizeData(_awayTableData, _awayTeamName);

            const updatedGraphData = [...dataList];
            const homeStats = setRecodeDataToGraph(updatedGraphData, _homeTableData, _homeTeamName, 0);
            const awayStats = setRecodeDataToGraph(updatedGraphData, _awayTableData, _awayTeamName, 1);

            setDataList(updatedGraphData);
            // 그래프 데이터
            setHomeRecordData(normalizedHomeData);
            setAwayRecordData(normalizedAwayData);
            // 팀 이름
            setHomeTeamName(_homeTeamName);
            setAwayTeamName(_awayTeamName);
            // n경기 n승 n 패
            setHomeRecordStats(homeStats);
            setAwayRecordStats(awayStats);

            setIsLoading(false);
          } else {
            console.log("데이터 불러오기 실패 -> ", responseResultDescription);
            setIsNullData(true);
            setIsLoading(false);
          }
        }).catch(err => console.log(err));
  }


  if (isLoading) {
    return (
        <div className="w-full h-screen flex flex-col justify-center items-center fixed top-0 left-0 overflow-hidden">
          <img src={getImage('loadingImage')} alt="loadingImage" className="h-32 w-auto"/>
          <span className="font-bold text-sky-700"> 데이터 불러오는중... </span>
        </div>
    )
  }
  if (isNullData) {
    return (
        <div className="w-full h-screen flex flex-col justify-center items-center fixed top-0 left-0 overflow-hidden">
          <img src={getImage('notFound')} alt="notFoundImage" className="h-40 w-auto"/>
          <span className="font-bold text-indigo-800 pt-3 text-lg pointer-events-auto"> 데이터가 없습니다. </span>
        </div>
    )
  }

  return (
      <div className="flex flex-col justify-center px-3 min-h-[calc(100vh-8rem)]">
        <div className="flex flex-row justify-between items-center">

          <div className="flex flex-row items-center">
            <span className="text-xl font-bold">최근전적 통계</span>

            <div className="flex flex-row justify-around items-center px-3 text-sm font-bold">
              <span className="text-white bg-rose-600 px-2 py-1 rounded-full">승</span>
              <span className="text-white bg-orange-400 px-2 py-1 rounded-full mx-2">무</span>
              <span className="text-white bg-blue-700 px-2 py-1 rounded-full">패</span>
            </div>
          </div>

          <div className="relative">
            <RiAlignJustify className="h-7 w-auto" onClick={() => setShowOptionButton(prevState => !prevState)}/>
            {showOptionButton &&
                <div className="absolute flex flex-col right-0 mt-1">
                  {buttonData.map((button) => {
                    return (
                        <button className="bg-gray-200 w-24 ring-2 ring-black py-1"
                                onClick={() => {
                                  setOptionButtonValue(button.value);
                                  setShowOptionButton(false);
                                }}
                        >
                          {button.name}
                        </button>
                    )
                  })}
                </div>
            }
          </div>
        </div>


        <div className="flex flex-row justify-between items-center font-bold">
          {/* <- 홈팀 원형그래프 -> */}
          <div className="w-1/2 flex flex-col justify-center items-center">
            <ChartDoughnut dataList={dataList[0]}/>
            <span className="bg-red-600 text-white rounded-full text-center py-0.5 min-w-32">
              {neverLandUtils.trimTeamName(homeTeamName)}
            </span>
            <span className="border border-black py-1 text-center rounded-full shadow-md px-2 text-sm my-2 min-w-32">
              {`${homeRecordStats.count}경기 ${homeRecordStats.win}승 ${homeRecordStats.draw}무 ${homeRecordStats.lose}패`}
            </span>
          </div>

          <span className="px-2 font-bold text-2xl">VS</span>

          {/* <- 원정팀 원형그래프 -> */}
          <div className="w-1/2 flex flex-col items-center">
            <ChartDoughnut dataList={dataList[1]}/>
            <span className="bg-blue-600 text-white rounded-full text-center py-0.5 min-w-32">
              {neverLandUtils.trimTeamName(awayTeamName)}
            </span>
            <span className="border border-black py-1 text-center rounded-full shadow-md px-2 text-sm my-2 min-w-32">
            {`${awayRecordStats.count}경기 ${awayRecordStats.win}승 ${awayRecordStats.draw}무 ${awayRecordStats.lose}패`}
            </span>
          </div>
        </div>


        {/* 홈팀 전적 테이블 */}
        <div>
          <h3 className="text-lg font-bold mt-8 mb-5 px-3 bg-red-200">{neverLandUtils.trimTeamName(homeTeamName)}</h3>
          <RecordDataTable tableData={homeRecordData} homeTeamName={homeTeamName} awayTeamName={awayTeamName}/>
        </div>

        {/* 원정팀 전적 테이블 */}
        <div>
          <h3 className="text-lg font-bold mt-8 mb-5 px-3 bg-blue-200">{neverLandUtils.trimTeamName(awayTeamName)}</h3>
          <RecordDataTable tableData={awayRecordData} homeTeamName={homeTeamName} awayTeamName={awayTeamName}/>
        </div>
      </div>
  )
}
export default RecentlyRecordeComponent;

